module.exports = __webpack_public_path__ + "static/media/eduTechImg1@2x.a014c4e5.webp";